import { Link, useParams } from 'react-router-dom';

import { DocSubset } from '@/api/types/backend-dto-types';
import { Icon } from '@/new/components/icon';
import { Button } from '@/new/components/shadcn/button';

export function RecentSubsets({ recentSubsets }: { recentSubsets: DocSubset[] }) {
  const { matterId } = useParams();
  if (!matterId) return;

  return (
    <div className="mb-6">
      <div className="mb-3 flex items-center justify-between">
        <h2 className="font-serif text-lg font-semibold text-gray-900">Recent Subsets</h2>
        <Link to={`/matters/${matterId}/subsets`} className="text-sm text-blue-600 hover:text-blue-700">
          View all
        </Link>
      </div>
      <div className="flex flex-col gap-2">
        {recentSubsets.length > 0 ? (
          recentSubsets.map((subset) => (
            <Link key={subset.id} to={`/matters/${matterId}/subsets/${subset.id}`}>
              <div className="group flex items-center justify-between rounded-md border border-gray-200 bg-white p-3 transition-all hover:border-gray-300">
                <div className="flex items-center gap-3">
                  <Icon className="lucide--group text-sm text-gray-500" />
                  <div>
                    <p className="font-medium text-gray-900">{subset.title}</p>
                    <p className="text-xs text-gray-500">{subset.docs.length} documents</p>
                  </div>
                </div>
                <Icon className="lucide--chevron-right text-gray-400 transition-transform group-hover:translate-x-1" />
              </div>
            </Link>
          ))
        ) : (
          <div className="rounded-md border border-gray-200 bg-white p-6 text-center">
            <Icon className="lucide--group mx-auto mb-2 text-2xl text-gray-400" />
            <p className="text-sm text-gray-500">No subsets created yet</p>
            <Link to={`/matters/${matterId}/subsets/new`}>
              <Button variant="outline" size="sm" className="mt-3">
                Create your first subset
              </Button>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
